<template>
  <perfect-scrollbar id="tableEditor" class="content" v-on:click="sectionClicked">
    <div class="getingData" v-if="getingData"></div>
    <div class="notFound" v-else-if="notFound">
      <div class="nfCnt">
        <img src="../assets/no-data.png">
        <h4>404 - Not Found</h4>
        <p>There is not table data for this section, you can create
          new one by clicking create button below.</p>
        <button class="btn btnSecondary add" v-on:click="createNew">Create New Table</button>
      </div>
    </div>
    <div v-else>
      <div class="tableAction">
        <template v-if="rowSelected">
          <div class="actionItem" v-on:click="clearRow">
            <img src="../assets/clear.png">
            Clear row</div>
          <div class="actionItem" v-on:click="addRowAbove">
            <img src="../assets/add-row.png">
            Add 1 row above</div>
          <div class="actionItem" v-on:click="addRowBelow">
            <img src="../assets/add-row.png">
            Add 1 row below</div>
          <div class="actionItem" v-on:click="deleteRow">
            <img src="../assets/delete.png" class="delete">
            Delete row</div>
        </template>
        <template v-else-if="colSelected">
          <div class="actionItem" v-on:click="clearCol">
            <img src="../assets/clear.png">
            Clear column</div>
          <div class="actionItem" v-on:click="addColLeft">
            <img src="../assets/add-row.png">
            Add 1 column left</div>
          <div class="actionItem" v-on:click="addColRight">
            <img src="../assets/add-row.png">
            Add 1 column right</div>
          <div class="actionItem" v-on:click="deleteCol">
            <img src="../assets/delete.png" class="delete">
            Delete column</div>
        </template>
        <template v-else>

          <div class="actionItem icon" v-on:click="toggleAlign('algn-l')">
            <img src="../assets/021-align-left.png">
            <span>Align left</span>
          </div>
          <div class="actionItem icon" v-on:click="toggleAlign('algn-c')">
            <img src="../assets/022-align.png">
            <span>Align center</span>
          </div>
          <div class="actionItem icon" v-on:click="toggleAlign('algn-r')">
            <img src="../assets/024-right-align.png">
            <span>Align right</span>
          </div>
          <div class="actionItem icon" v-on:click="toggleAlign('algn-j')">
            <img src="../assets/023-align-1.png">
            <span>Align justify</span>
          </div>

          <div class="actionDivider"></div>

          <div class="actionItem icon" v-on:click="toggleClass('txt-b')">
            <img src="../assets/026-bold.png">
            <span>Bold</span>
          </div>
          <div class="actionItem icon" v-on:click="toggleClass('txt-i')">
            <img src="../assets/italics.png" class="italic">
            <span>Italic</span>
          </div>
          <div class="actionItem icon" v-on:click="toggleClass('txt-u')">
            <img src="../assets/025-underline.png">
            <span>Underline</span>
          </div>

          <div class="actionDivider"></div>

          <div class="actionItem icon" v-on:click="setTextColor">
            <img src="../assets/028-text.png">
            <span>Text color</span>
          </div>
          <div class="actionItem icon" v-on:click="setBgColor">
            <img src="../assets/027-color.png">
            <span>Background color</span>
          </div>

          <div class="actionDivider"></div>

          <div class="actionItem icon" v-on:click="setBorder('none')">
            <img src="../assets/020-border-8.png">
          </div>
          <div class="actionItem icon" v-on:click="setBorder('left')">
            <img src="../assets/018-left-border.png">
          </div>
          <div class="actionItem icon" v-on:click="setBorder('right')">
            <img src="../assets/016-border-5.png">
          </div>
          <div class="actionItem icon" v-on:click="setBorder('bottom')">
            <img src="../assets/019-border-7.png">
          </div>
          <div class="actionItem icon" v-on:click="setBorder('top')">
            <img src="../assets/015-border-4.png">
          </div>
          <div class="actionItem icon" v-on:click="setBorder('h')">
            <img src="../assets/013-border-2.png">
          </div>
          <div class="actionItem icon" v-on:click="setBorder('v')">
            <img src="../assets/013-border-2-a.png">
          </div>
          <div class="actionItem icon" v-on:click="setBorder('outer')">
            <img src="../assets/017-border-6.png">
          </div>
          <div class="actionItem icon" v-on:click="setBorder('full')">
            <img src="../assets/011-border.png">
          </div>

          <div class="actionDivider"></div>

          <div class="actionItem icon" v-on:click="mergeCell">
            <img src="../assets/cells.png">
            <span>Merge cell</span>
          </div>

          <div class="actionDivider"></div>

          <div class="actionItem icon" v-on:click="addAtt">
            <img src="../assets/attachment.png" class="attachment">
            <span>Attachment</span>
          </div>
          <div class="actionItem icon" v-on:click="setCssClass">
            <img src="../assets/css.png" class="attachment">
            <span>CSS Classes</span>
          </div>
        </template>
      </div>
      <div class="tableSc">
        <div class="tableCnt" :style="{width: `${(rowCount * 101) + 70 + 40}px`}">
          <table border="0" cellpadding="0" cellspacing="0">
            <tr>
              <td></td>
              <td class="tdRow" v-for="iRow in rowCount" :key="`tdIdx${iRow}`"
                :class="{tdRow1: iRow === 1, selected: colSelected === iRow}"
                v-on:click="selectCol(iRow)">{{iRow}}</td>
            </tr>
            <tr v-for="(tr, i) in trs" :key="`tr${i}`">
              <td class="tdCol" :class="{tdCol1: i === 0, selected: rowSelected - 1 === i}"
                v-on:click="selectRow(i + 1)">{{i + 1}}</td>
              <td v-for="(td, i2) in tr.tds" :key="`td${i2}`"
                :style="{'background-color': td.options.bgColor, color: td.options.textColor}"
                :colspan="td.options.colspan" :class="[td.options.class, {selected: td.selected,
                hasCustomCss: (td.options.customCss), hasAtt: (td.options.attachments)}]">
                <div class="tdContent" :class="{merged: td.options.colspan}">
                  <div class="tdValue" contenteditable v-on:input="valueChanged($event, td)"
                    v-on:click="selectCell($event, i, i2)"
                    v-on:paste="cellPasted">{{td.value}}</div>
                  <div class="tdBorder lt"></div>
                  <div class="tdBorder rb"></div>
                  <div class="tdBorder rt"></div>
                  <div class="tdBorder lb"></div>
                </div>
              </td>
            </tr>
          </table>
          <div class="addMore addNewRow" v-on:click="addMoreRow"></div>
          <div class="addMore addNewCol" v-on:click="addMoreCol"></div>
        </div>
      </div>
      <div class="formAction">
        <div class="formActionCnt" v-if="trsTmp !== ''">
          <button class="btn btnSecondary" v-on:click="cancelRevert">
            <span>Cancel</span>
          </button>
          <div class="saveBtnCnt revertBtn">
            <button class="btn btnPrimary" v-on:click="revertVersion">
              <span>Revert to this version</span>
            </button>
          </div>
        </div>
        <div class="formActionCnt" v-else>
          <div class="saveBtnCnt canSaveDraft"
            :class="{loading: saving, disabled: btnDisabled}">
            <button :class="{btn: true, btnPrimary: true, disabled: false, btnLoading: saving}"
              v-on:click="doSave('published')">
              <span>Publish</span>
            </button>
            <div class="moreBtn" v-on:click="openMoreOptions"></div>
            <div class="moreOptionOverlay" v-if="showMoreOptions && !btnDisabled"
              v-on:click="showMoreOptions = false"></div>
            <div class="moreOption" v-if="showMoreOptions && !btnDisabled">
              <li v-on:click="saveStay" class="draft">Save and stay</li>
              <li v-on:click="doSave('published')" class="preview">Save and exit</li>
            </div>
          </div>
          <div class="btnConfig" v-if="!saving && table">
            <div class="theBtn" v-on:click="openConfig"></div>
            <div class="configOverlay" v-if="configOpen"
              v-on:click="configOpen = false"></div>
            <div class="configContent" v-if="configOpen">
              <div class="configItem" v-if="section">
                <h4>Table info</h4>
                <div class="ciItem">
                  Section
                  <span v-if="section.name || section.title">
                    {{section.name}}<template v-if="section.name && section.title">
                    - </template>{{section.title}}
                  </span>
                  <span v-else>Unknown</span>
                </div>
                <template v-if="table">
                  <div class="ciItem">
                    Author
                    <span v-if="table.author">
                      {{table.author.name}}</span>
                    <span v-else>Unknown</span>
                  </div>
                  <div class="ciItem">
                    Last edited
                    <span v-if="table.lastEdited">
                      {{table.lastEdited | moment('D MMM YYYY HH:mm')}}</span>
                    <span v-else>Never</span>
                  </div>
                  <div class="ciItem" v-if="table.lastEditor">
                    Last edited by
                    <span>{{table.lastEditor.name}}</span>
                  </div>
                </template>
              </div>
              <div class="configItem">
                <h4>History</h4>
                <div class="loadingHistory" v-if="loadingHistory"></div>
                <div class="historyCnt noData" v-else-if="history.length < 1">
                  There are currently no history
                </div>
                <div class="historyCnt" v-else>
                  <div class="historyItem" v-for="item in history" :key="`h${item.id}`"
                    v-on:click="selectHistory(item)">
                    <h5>{{item.timestamp | moment('D MMMM YYYY HH:mm')}}</h5>
                    <p v-if="item.author">edited by <b>{{item.author.name}}</b></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MediaSelector ref="mediaSelector"/>
    <Confirmation ref="confirmDialog"/>
    <LoadingDialog ref="loadingDialog"/>
    <Snackbar ref="snackbar"/>
    <ColorPicker ref="colorPicker"/>
    <AddDialog ref="addDialog"/>
    <AttachmentSelector ref="attachmentSelector"/>
    <AttViewer ref="attViewer"/>
  </perfect-scrollbar>
</template>

<script>
import { mapActions } from 'vuex';
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

import MediaSelector from '@/components/MediaSelector.vue';
import Confirmation from '@/components/Confirmation.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import Snackbar from '@/components/Snackbar.vue';
import ColorPicker from '@/components/ColorPicker.vue';
import AttachmentSelector from '@/components/AttachmentSelector.vue';
import AddDialog from '@/components/AddDialog.vue';
import AttViewer from '@/components/AttViewer.vue';

export default {
  name: 'editor',
  components: {
    MediaSelector,
    Confirmation,
    LoadingDialog,
    ColorPicker,
    Snackbar,
    AttachmentSelector,
    AddDialog,
    AttViewer,
  },
  data() {
    return {
      rowCount: 0,
      trs: [],
      trsTmp: '',
      rowSelected: null,
      colSelected: null,
      sectionId: null,
      id: null,
      showMoreOptions: false,
      section: null,
      configOpen: false,
      table: null,
      loadingHistory: true,
      history: [],
      btnDisabled: false,
      saving: false,
      getingData: true,
      notFound: false,
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    sectionClicked() {},
    doNothing() {},
    insertAtt(att) {
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          // eslint-disable-next-line
          if (!td.selected) continue;
          td.options.attachments = att;
        }
      }
    },
    editAtt(currentAtt) {
      if (currentAtt.type === 'media') {
        this.$refs.mediaSelector.open({ type: 'all' }, (b2, media) => {
          if (!b2) return;
          const att = { id: media.id, name: media.name, uri: media.uri };
          this.insertAtt({ type: currentAtt.type, value: att });
        });
      } else if (currentAtt.type === 'link') {
        this.$refs.confirmDialog.open({
          title: 'Link url',
          desc: 'Input link url as attachment',
          action: 'Insert Attachment',
          inputs: [
            {
              label: 'Url',
              type: 'text',
              value: currentAtt.value,
            },
          ],
        }, (b2, c, d, v) => {
          if (!b2) return;
          let link = v[0].value;
          if (link.indexOf('http://') !== 0 && link.indexOf('https://') !== 0
            && link.indexOf('/') !== 0) {
            link = `https://${link}`;
          }
          this.insertAtt({ type: currentAtt.type, value: link });
        });
      } else {
        this.$refs.addDialog.open({ contents: currentAtt.value }, (b2, v) => {
          if (!b2) return;
          this.insertAtt({ type: currentAtt.type, value: v });
        });
      }
    },
    doAddAtt(currentAtt) {
      if (currentAtt) {
        // Display current attachment
        this.$refs.attViewer.open(currentAtt, (b, action) => {
          if (!b) return;
          if (action === 'edit') this.editAtt(currentAtt);
          else if (action === 'delete') this.insertAtt(null);
        });
      } else {
        // Create new attachment
        this.$refs.attachmentSelector.open((b, type) => {
          if (!b) return;
          if (type === 'media') {
            this.$refs.mediaSelector.open({ type: 'all' }, (b2, media) => {
              if (!b2) return;
              const att = { id: media.id, name: media.name, uri: media.uri };
              this.insertAtt({ type, value: att });
            });
          } else if (type === 'link') {
            this.$refs.confirmDialog.open({
              title: 'Link url',
              desc: 'Input link url as attachment',
              action: 'Insert Attachment',
              inputs: [
                {
                  label: 'Url',
                  type: 'text',
                  value: '',
                },
              ],
            }, (b2, c, d, v) => {
              if (!b2) return;
              let link = v[0].value;
              if (link.indexOf('http://') !== 0 && link.indexOf('https://') !== 0
                && link.indexOf('/') !== 0) {
                link = `https://${link}`;
              }
              this.insertAtt({ type, value: link });
            });
          } else {
            this.$refs.addDialog.open(null, (b2, contents) => {
              if (!b2) return;
              this.insertAtt({ type, value: contents });
            });
          }
        });
      }
    },
    addAtt() {
      let multipel = false;
      let currentAtt = null;
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          // eslint-disable-next-line
          if (!td.selected) continue;
          if (td.options && td.options.attachments) {
            if (!currentAtt) currentAtt = td.options.attachments;
            else multipel = true;
          }
        }
      }

      if (multipel) {
        this.$refs.confirmDialog.open({
          title: 'Multiple Cell Selected',
          desc: `There are multiple selected cell with attachment,
            you want to overwrite current attachment settings for selected cell?
            If you want to see current attachment, select one cell then click attachment icon`,
          action: 'Overwrite',
        }, (b) => {
          if (b) this.doAddAtt(currentAtt);
        });
      } else {
        this.doAddAtt(currentAtt);
      }
    },
    selectHistory(item) {
      this.configOpen = false;
      this.trsTmp = JSON.stringify(this.trs);
      this.trs = item.trs;
    },
    revertVersion() {
      this.trsTmp = '';
    },
    cancelRevert() {
      this.trs = JSON.parse(this.trsTmp);
      this.trsTmp = '';
    },
    clearSelections() {
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          td.selected = false;
        }
      }
    },
    selectRow(i) {
      this.clearSelections();
      this.colSelected = null;
      this.rowSelected = i;
    },
    selectCol(i) {
      this.clearSelections();
      this.rowSelected = null;
      this.colSelected = i;
    },
    selectAlongTheWay(toX, toY) {
      const selectionStart = { x: 0, y: 0 };
      let x = 0;
      // eslint-disable-next-line
      for (const tr of this.trs) {
        let y = 0;
        if (x > toX) break;
        // eslint-disable-next-line
        for (const td of tr.tds) {
          if (y > toY) break;
          if (td.selected && !selectionStart.x) {
            selectionStart.x = x + 1;
            selectionStart.y = y + 1;
          } else if (!td.selected && selectionStart.x) {
            // eslint-disable-next-line
            if (y >= selectionStart.y - 1) td.selected = true;
          }
          y += td.options.colspan || 1;
        }
        x += 1;
      }
    },
    selectCell(e, x, y) {
      this.rowSelected = null;
      this.colSelected = null;
      if (!e.ctrlKey && !e.shiftKey) {
        this.clearSelections();
        this.trs[x].tds[y].selected = true;
      } else {
        this.trs[x].tds[y].selected = true;

        /**
         * Find the last x y
         *
         */
        const lastXY = { x: 0, y: 0 };
        let x2 = 0;
        // eslint-disable-next-line
        for (const tr of this.trs) {
          let y2 = 0;
          // eslint-disable-next-line
          for (const td of tr.tds) {
            if (td.selected) {
              lastXY.x = x2 + 1;
              lastXY.y = y2 + 1;
            }
            y2 += td.options.colspan || 1;
          }
          x2 += 1;
        }

        /**
         * Select along the way
         *
         */
        this.selectAlongTheWay(lastXY.x - 1, lastXY.y - 1);
      }
    },
    cellPasted(e) {
      e.preventDefault();
      const text = (e.originalEvent || e).clipboardData.getData('text/plain');
      document.execCommand('insertHTML', false, text);
    },
    valueChanged(e, td) {
      if (!td.model) td.model = ''; // eslint-disable-line
      td.model = e.target.innerText; // eslint-disable-line
    },
    addMoreRow() {
      this.rowCount += 1;
      // eslint-disable-next-line
      for (const item of this.trs) {
        // eslint-disable-next-line
        item.tds.push({ value: '', model: '', selected: false, options: {} });
      }
      // this.$refs.confirmDialog.open({
      //   title: 'Add More Column',
      //   desc: null,
      //   action: 'Add Column',
      //   inputs: [
      //     {
      //       label: 'Column Count',
      //       type: 'number',
      //       value: 1,
      //     },
      //   ],
      // }, (b, c, d, v) => {
      //   if (!b) return;
      //   const rowCount = parseInt(v[0].value, 10);
      //   this.rowCount += rowCount;
      //   for (let i = 0; i < rowCount; i += 1) {
      //     // eslint-disable-next-line
      //     for (const item of this.trs) {
      //       // eslint-disable-next-line
      //       item.tds.push({ value: '', model: '', selected: false, options: {} });
      //     }
      //   }
      // });
    },
    addMoreCol() {
      this.trs.push({ options: {}, tds: this.genRows() });
      // this.$refs.confirmDialog.open({
      //   title: 'Add More Column',
      //   desc: null,
      //   action: 'Add Row',
      //   inputs: [
      //     {
      //       label: 'Row Count',
      //       type: 'number',
      //       value: 1,
      //     },
      //   ],
      // }, (b, c, d, v) => {
      //   if (!b) return;
      //   const rowCount = parseInt(v[0].value, 10);
      //   for (let i = 0; i < rowCount; i += 1) {
      //     this.trs.push({ options: {}, tds: this.genRows() });
      //   }
      // });
    },
    genRows() {
      const tds = [];
      for (let i = 0; i < this.rowCount; i += 1) {
        tds.push({
          value: '',
          model: '',
          selected: false,
          options: {},
        });
      }
      return tds;
    },
    deleteCol() {
      this.rowCount -= 1;
      // eslint-disable-next-line
      for (const tr of this.trs) {
        let idx = JSON.parse(JSON.stringify(this.colSelected));
        let i = 0;
        // eslint-disable-next-line
        for (const td of tr.tds) {
          const cellCount = (td.options && td.options.colspan) ? td.options.colspan : 1;
          idx -= cellCount;
          if (idx <= 0) {
            if (cellCount > 1) {
              td.options.colspan -= 1;
              if (td.options.colspan <= 1) td.options.colspan = null;
            } else {
              tr.tds.splice(i, 1);
            }
            break;
          }
          i += 1;
        }
      }
    },
    clearCol() {
      // eslint-disable-next-line
      for (const tr of this.trs) {
        let idx = JSON.parse(JSON.stringify(this.colSelected));
        // eslint-disable-next-line
        for (const td of tr.tds) {
          const cellCount = (td.options && td.options.colspan) ? td.options.colspan : 1;
          idx -= cellCount;
          if (idx <= 0) {
            td.value = '';
            td.model = '';
            td.options = {};
            break;
          }
        }
      }
    },
    addColLeft() {
      this.rowCount += 1;
      // eslint-disable-next-line
      for (const tr of this.trs) {
        let idx = JSON.parse(JSON.stringify(this.colSelected));
        let i = 0;
        // eslint-disable-next-line
        for (const td of tr.tds) {
          const cellCount = (td.options && td.options.colspan) ? td.options.colspan : 1;
          idx -= cellCount;
          if (idx <= 0) {
            if (cellCount > 1) {
              td.options.colspan += 1;
            } else {
              tr.tds.splice(i, 0, {
                value: '',
                model: '',
                selected: false,
                options: {},
              });
            }
            break;
          }
          i += 1;
        }
      }
    },
    addColRight() {
      this.rowCount += 1;
      // eslint-disable-next-line
      for (const tr of this.trs) {
        let idx = JSON.parse(JSON.stringify(this.colSelected));
        let i = 0;
        // eslint-disable-next-line
        for (const td of tr.tds) {
          const cellCount = (td.options && td.options.colspan) ? td.options.colspan : 1;
          idx -= cellCount;
          if (idx <= 0) {
            if (cellCount > 1) {
              td.options.colspan += 1;
            } else {
              tr.tds.splice(i + 1, 0, {
                value: '',
                model: '',
                selected: false,
                options: {},
              });
            }
            break;
          }
          i += 1;
        }
      }
    },
    clearRow() {
      // eslint-disable-next-line
      for (const td of this.trs[this.rowSelected - 1].tds) {
        td.value = '';
        td.model = '';
        td.options = {};
      }
    },
    addRowAbove() {
      this.trs.splice(this.rowSelected - 1, 0, { options: {}, tds: this.genRows() });
    },
    addRowBelow() {
      this.trs.splice(this.rowSelected, 0, { options: {}, tds: this.genRows() });
      this.rowSelected += 1;
    },
    deleteRow() {
      this.trs.splice(this.rowSelected - 1, 1);
    },
    mergeCell() {
      const m = { a: { x: 0, y: 0 }, b: { x: 0, y: 0 }, l: 0 };
      let y = 1;
      // eslint-disable-next-line
      for (const tr of this.trs) {
        let x = 1;
        // eslint-disable-next-line
        for (const td of tr.tds) {
          if (td.selected) {
            if (m.a.x === 0 && m.a.y === 0) {
              m.a.x = x;
              m.a.y = y;
            } else {
              m.b.x = x;
              m.b.y = y;
              if (m.a.y !== m.b.y) {
                this.$refs.confirmDialog.open({
                  title: 'Merge Cell Failed',
                  desc: 'Can not merge row, only can merge two or more cell in the same row.',
                  error: true,
                });
                return;
              }
            }
          }
          if (m.a.x && td.selected) m.l += td.options.colspan || 1;
          x += 1;
        }
        y += 1;
      }
      if (m.b.x === 0 || m.a.x === m.b.x) {
        if (this.trs[m.a.y - 1].tds[m.a.x - 1].options.colspan
          && this.trs[m.a.y - 1].tds[m.a.x - 1].options.colspan > 1) {
          // Unmerge
          for (let i = 0; i < this.trs[m.a.y - 1].tds[m.a.x - 1].options.colspan - 1; i += 1) {
            this.trs[m.a.y - 1].tds.splice(m.a.x, 0, {
              value: '',
              model: '',
              selected: false,
              options: {},
            });
          }
          this.trs[m.a.y - 1].tds[m.a.x - 1].options.colspan = 1;
        }
        this.clearSelections();
        return;
      }

      let spaceRequired = m.l;
      spaceRequired -= this.trs[m.a.y - 1].tds[m.a.x - 1].options.colspan || 1;
      let tried = 0;
      while (spaceRequired > 0) {
        let i = -1;
        // eslint-disable-next-line
        for (const td of this.trs[m.a.y - 1].tds) {
          i += 1;
          // eslint-disable-next-line
          if (i <= m.a.x - 1) continue;
          spaceRequired -= (td.options && td.options.colspan) ? td.options.colspan : 1;
          this.trs[m.a.y - 1].tds.splice(i, 1);
          break;
        }
        tried += 1;
        if (tried >= 500) break;
      }

      if (!this.trs[m.a.y - 1].tds[m.a.x - 1].options) {
        this.trs[m.a.y - 1].tds[m.a.x - 1].options = {};
      }
      this.trs[m.a.y - 1].tds[m.a.x - 1].options.colspan = m.l;
      this.clearSelections();
    },
    setBorder(border) {
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          // eslint-disable-next-line
          if (!td.selected) continue;
          if (!td.options) td.options = {};
          if (!td.options.class) td.options.class = '';
          if (['none', 'full', 'outer'].includes(border)) {
            const allBorder = ['vll', 'vll-t', 'vll-b', 'vlr', 'vlr-t', 'vlr-b',
              'vlm', 'vlm-t', 'vlm-b', 'hlt', 'hlt-l', 'hlt-r', 'hlb', 'hlb-l', 'hlb-r',
              'hlm', 'hlm-l', 'hlm-r'];
            // eslint-disable-next-line
            for (const ab of allBorder) {
              td.options.class = td.options.class.replace(ab, '');
            }
            if (border === 'full') {
              td.options.class += ' vll vlm vlr hlt hlb hlm ';
            } else if (border === 'outer') {
              td.options.class += ' vll vlr hlt hlb';
            }
          } else if (border === 'left') {
            if (td.options.class.indexOf('vll') >= 0) {
              if (td.options.class.indexOf('vll-t') < 0 && td.options.class.indexOf('vll-b') < 0) {
                td.options.class += ' vll-t ';
              } else if (td.options.class.indexOf('vll-t') >= 0) {
                td.options.class = td.options.class.replace('vll-t', '');
                td.options.class += ' vll-b ';
              } else {
                td.options.class = td.options.class.replace('vll', '');
                td.options.class = td.options.class.replace('vll-t', '');
                td.options.class = td.options.class.replace('vll-b', '');
              }
            } else {
              td.options.class += ' vll ';
            }
          } else if (border === 'right') {
            if (td.options.class.indexOf('vlr') >= 0) {
              if (td.options.class.indexOf('vlr-t') < 0 && td.options.class.indexOf('vlr-b') < 0) {
                td.options.class += ' vlr-t ';
              } else if (td.options.class.indexOf('vlr-t') >= 0) {
                td.options.class = td.options.class.replace('vlr-t', '');
                td.options.class += ' vlr-b ';
              } else {
                td.options.class = td.options.class.replace('vlr', '');
                td.options.class = td.options.class.replace('vlr-t', '');
                td.options.class = td.options.class.replace('vlr-b', '');
              }
            } else {
              td.options.class += ' vlr ';
            }
          } else if (border === 'v') {
            if (td.options.class.indexOf('vlm') >= 0) {
              if (td.options.class.indexOf('vlm-t') < 0 && td.options.class.indexOf('vlm-b') < 0) {
                td.options.class += ' vlm-t ';
              } else if (td.options.class.indexOf('vlm-t') >= 0) {
                td.options.class = td.options.class.replace('vlm-t', '');
                td.options.class += ' vlm-b ';
              } else {
                td.options.class = td.options.class.replace('vlm', '');
                td.options.class = td.options.class.replace('vlm-t', '');
                td.options.class = td.options.class.replace('vlm-b', '');
              }
            } else {
              td.options.class += ' vlm ';
            }
          } else if (border === 'top') {
            if (td.options.class.indexOf('hlt') >= 0) {
              if (td.options.class.indexOf('hlt-l') < 0 && td.options.class.indexOf('hlt-r') < 0) {
                td.options.class += ' hlt-l ';
              } else if (td.options.class.indexOf('hlt-l') >= 0) {
                td.options.class = td.options.class.replace('hlt-l', '');
                td.options.class += ' hlt-r ';
              } else {
                td.options.class = td.options.class.replace('hlt', '');
                td.options.class = td.options.class.replace('hlt-l', '');
                td.options.class = td.options.class.replace('hlt-r', '');
              }
            } else {
              td.options.class += ' hlt ';
            }
          } else if (border === 'bottom') {
            if (td.options.class.indexOf('hlb') >= 0) {
              if (td.options.class.indexOf('hlb-l') < 0 && td.options.class.indexOf('hlb-r') < 0) {
                td.options.class += ' hlb-l ';
              } else if (td.options.class.indexOf('hlb-l') >= 0) {
                td.options.class = td.options.class.replace('hlb-l', '');
                td.options.class += ' hlb-r ';
              } else {
                td.options.class = td.options.class.replace('hlb', '');
                td.options.class = td.options.class.replace('hlb-l', '');
                td.options.class = td.options.class.replace('hlb-r', '');
              }
            } else {
              td.options.class += ' hlb ';
            }
          } else if (border === 'h') {
            if (td.options.class.indexOf('hlm') >= 0) {
              if (td.options.class.indexOf('hlm-l') < 0 && td.options.class.indexOf('hlm-r') < 0) {
                td.options.class += ' hlm-l ';
              } else if (td.options.class.indexOf('hlm-l') >= 0) {
                td.options.class = td.options.class.replace('hlm-l', '');
                td.options.class += ' hlm-r ';
              } else {
                td.options.class = td.options.class.replace('hlm', '');
                td.options.class = td.options.class.replace('hlm-l', '');
                td.options.class = td.options.class.replace('hlm-r', '');
              }
            } else {
              td.options.class += ' hlm ';
            }
          }

          td.options.class = td.options.class.replace(/  +/g, ' ');
        }
      }
    },
    toggleClass(className) {
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          // eslint-disable-next-line
          if (!td.selected) continue;
          if (!td.options) td.options = {};
          if (!td.options.class) td.options.class = '';
          if (td.options.class.indexOf(className) >= 0) {
            td.options.class = td.options.class.replace(className, '');
          } else {
            td.options.class += ` ${className} `;
          }
          td.options.class = td.options.class.replace(/  +/g, ' ');
        }
      }
    },
    toggleAlign(className) {
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          // eslint-disable-next-line
          if (!td.selected) continue;
          if (!td.options) td.options = {};
          if (!td.options.class) td.options.class = '';
          const allBorder = ['algn-l', 'algn-r', 'algn-c', 'algn-j'];
          // eslint-disable-next-line
          for (const ab of allBorder) {
            td.options.class = td.options.class.replace(ab, '');
          }
          td.options.class += ` ${className} `;
          td.options.class = td.options.class.replace(/  +/g, ' ');
        }
      }
    },
    setTextColor() {
      let color = null;
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          // eslint-disable-next-line
          if (!td.selected) continue;
          if (!color && td.options && td.options.textColor) {
            color = td.options.textColor;
          }
        }
      }
      this.$refs.colorPicker.open({ type: 'chrome', color }, (b, c) => {
        if (!b) return;
        // eslint-disable-next-line
        for (const tr of this.trs) {
          // eslint-disable-next-line
          for (const td of tr.tds) {
            // eslint-disable-next-line
            if (!td.selected) continue;
            td.options.textColor = c;
          }
        }
      });
    },
    setBgColor() {
      let color = null;
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          // eslint-disable-next-line
          if (!td.selected) continue;
          if (!color && td.options && td.options.bgColor) {
            color = td.options.bgColor;
          }
        }
      }
      this.$refs.colorPicker.open({ type: 'chrome', color }, (b, c) => {
        if (!b) return;
        // eslint-disable-next-line
        for (const tr of this.trs) {
          // eslint-disable-next-line
          for (const td of tr.tds) {
            // eslint-disable-next-line
            if (!td.selected) continue;
            td.options.bgColor = c;
          }
        }
      });
    },
    setCssClass() {
      let classes = '';
      // eslint-disable-next-line
      for (const tr of this.trs) {
        // eslint-disable-next-line
        for (const td of tr.tds) {
          // eslint-disable-next-line
          if (!td.selected) continue;
          if (classes === '' && td.options && td.options.customCss) {
            classes = td.options.customCss;
          }
        }
      }

      this.$refs.confirmDialog.open({
        title: 'CSS Classes',
        desc: 'Write custom css for selected cell',
        action: 'Set Classes',
        inputs: [
          {
            label: 'CSS Classes',
            type: 'longtext',
            value: classes,
          },
        ],
      }, (b, c, d, v) => {
        if (!b) return;
        // eslint-disable-next-line
        for (const tr of this.trs) {
          // eslint-disable-next-line
          for (const td of tr.tds) {
            // eslint-disable-next-line
            if (!td.selected) continue;
            td.options.customCss = v[0].value;
          }
        }
      });
    },

    createNew() {
      // this.getingData = true;
      this.notFound = false;
      for (let i = 0; i < 10; i += 1) {
        this.addMoreCol();
        this.addMoreRow();
      }
      // this.doSave('published', () => {
      //   this.getData();
      // });
    },
    saveStay() {
      this.showMoreOptions = false;
      this.doSave('published', () => {
        this.$refs.snackbar.open({ content: 'Changes has been saved' });
      });
    },
    doSave(status, next) {
      if (this.saving || this.btnDisabled) return;
      const tableId = (this.table && this.table.id) ? this.table.id : null;
      const formData = {
        id: tableId,
        trs: this.trs,
      };
      this.saving = true;
      this.$http.post(this.$config.uri(`section/${this.sectionId}/table`), formData).then((r) => {
        if (r.data.status !== 200) {
          // Display error
          return;
        }
        this.saving = false;
        if (next) next(r.data);
        else this.$router.push('/homepage/sections');
      });
    },
    getData() {
      this.$http.get(this.$config.uri(`section/${this.sectionId}/table`)).then((r) => {
        this.getingData = false;
        if (r.data.status !== 200) {
          this.notFound = true;
          return;
        }

        const { data } = r.data;
        this.trs = r.data.data.trs;
        this.table = {
          id: data.id,
          author: data.author,
          dateCreated: data.dateCreated,
          lastEdited: data.lastEdited,
          lastEditor: data.lastEditor,
        };
        this.rowCount = 0;
        // eslint-disable-next-line
        for (const item of this.trs[0].tds) {
          this.rowCount += (item.options && item.options.colspan) ? item.options.colspan : 1;
        }
      }).catch((err) => {
        this.getingData = false;
        this.notFound = true;
      });
    },
    openConfig() {
      this.configOpen = true;
      if (!this.table) return;
      this.$http.get(this.$config.uri(`section/table/${this.table.id}/history`)).then((r) => {
        this.loadingHistory = false;
        this.history = (r.data.status === 200) ? r.data.data : [];
      });
    },
    openMoreOptions() {
      if (this.btnDisabled) return;
      this.showMoreOptions = !this.showMoreOptions;
    },
  },
  mounted() {
    this.chCGB(true);
    this.chTitle('Table Editor');
    this.sectionId = this.$route.params.id;
    this.getData();

    this.$http.get(this.$config.uri(`section/all?id=${this.sectionId}`)).then((r) => {
      this.section = (r.data.status === 200) ? r.data.data : null;
    });
  },
};
</script>

<style scoped lang="scss">
#tableEditor.content{
  height: calc(100vh - 104px);
  padding: 0;
}
.getingData{
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url(../assets/loading-2.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 46px auto;
}
.notFound{
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  img{
    height: 64px;
    margin-bottom: 40px;
  }
  h4{
    font-size: 30px;
    font-weight: normal;
    margin: 0 0 10px;
  }
  p{
    max-width: 420px;
    color: #767676;
    font-size: 15px;
    margin: 0 0 16px;
  }
}


/**
 * Table style
 *
 */
.tableAction{
  position: fixed;
  left: 300px; right: 0; height: 40px; top: 49px;
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-bottom: #eee 1px solid;
  box-sizing: border-box;
  z-index: 3;
  .actionDivider{
    margin: 0 12px;
    width: 1px;
    background-color: #eee;
    height: 24px;
  }
  .actionItem{
    padding: 6px 14px;
    // border: #eee 1px solid;
    border-radius: 50px;
    margin-right: 10px;
    font-size: 15px;
    cursor: pointer;
    position: relative;
    padding-left: 38px;
    transition: all .3s ease;
    background-color: #f5f5f5;
    img{
      height: 20px;
      position: absolute;
      left: 10px; top: 50%;
      transform: translateY(-50%);
      &.delete{
        height: 16px;
        left: 12px;
      }
    }
    &:hover{
      background-color: #eee;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
    }
    &.icon{
      height: 30px; width: 30px;
      padding: 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      margin-right: 4px;
      background-color: #fff;
      box-shadow: none;
      &:hover{
        background-color: #eee;
      }
      img{
        position: static;
        transform: none;
        &.italic{
          height: 13px;
        }
        &.attachment{
          height: 16px;
        }
      }
      span{
        position: absolute;
        left: 50%; top: 100%;
        transform: translateX(-50%) scale(.9);
        background-color: #000;
        color: #fff;
        font-size: 11px;
        white-space: nowrap;
        padding: 2px 6px 3px;
        border-radius: 2px;
        opacity: 0;
        visibility: hidden;
        transition: all .3s ease;
      }
      &:hover{
        span{
          transform: translateX(-50%);
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
}
.tableSc{
  position: fixed;
  left: 300px; right: 0; top: 89px; bottom: 56px;
  overflow: auto;
}
.tableCnt{
  padding: 0 70px 70px 0;
  position: relative;
  box-sizing: border-box;
  .addMore{
    width: 30px; height: 30px;
    background-image: url(../assets/plus-circle.png);
    background-size: 30px auto;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
    transition: all .3s ease;
    cursor: pointer;
    &:hover{
      box-shadow: 0 0 6px rgba(0, 0, 0, .2);
    }
  }
  .addNewRow{
    position: absolute;
    right: 30px; top: 10px;
  }
  .addNewCol{
    position: absolute;
    left: 10px; bottom: 30px;
  }
  table{
    border: none;
    border: #ccc 1px solid;
    &:hover{
      border-color: #0057d8;
    }
    tr td{
      border-right: #eee 1px solid;
      border-bottom: #eee 1px solid;
      overflow: hidden;
      width: 100px;
      height: 40px;
      box-sizing: border-box;
      &.selected{
        .tdContent{
          background-color: rgba(0, 104, 255, .13);
        }
      }
      &.hasAtt{
        .tdContent{
          &:after{
            content: "";
            width: 4px; height: 4px;
            background-color: blue;
            border-radius: 50%;
            position: absolute;
            right: 6px; top: 6px;
          }
        }
        &.hasCustomCss{
          .tdContent{
            &:after{
              right: 12px;
            }
          }
        }
      }
      &.hasCustomCss{
        .tdContent{
          &:before{
            content: "";
            width: 4px; height: 4px;
            background-color: red;
            border-radius: 50%;
            position: absolute;
            right: 6px; top: 6px;
          }
        }
      }
      .tdContent{
        width: 100px;
        height: 100%;
        min-height: 38px;
        position: relative;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        &.merged{
          width: 100%;
        }
      }
      &.tdRow{
        background-color: #eee;
        height: 30px;
        text-align: center;
        font-weight: 600;
        border-color: #ccc;
        cursor: pointer;
        &.selected{
          background-color: #0057d8;
          color: #fff;
        }
        .tdContent{
          align-items: center;
          justify-content: center;
          padding-right: 20px;
        }
        &.tdRow1{
          border-left: #ccc 1px solid;
        }
      }
      &.tdCol{
        background-color: #eee;
        text-align: center;
        font-weight: 600;
        border-color: #ccc;
        width: 40px;
        text-align: center;
        cursor: pointer;
        &.selected{
          background-color: #0057d8;
          color: #fff;
        }
        &.tdCol1{
          border-top: #ccc 1px solid;
        }
      }
    }
    .tdValue{
      position: relative;
      z-index: 9;
      height: 100%; width: 100%;
      border: transparent 2px solid;
      outline: 0;
      padding: 2px 4px;
      box-sizing: border-box;
      &:hover{
        border-color: #999;
      }
      &:focus{
        // background-color: #fff;
        border-color: #0057d8;
      }
    }
    .tdBorder{
      width: calc(50% - 1.5px); height: calc(50% - 1.5px);
      border: transparent 1px solid;
      position: absolute;
      &.lt{ left: 0; top: 0; }
      &.rb{ right: 0; bottom: 0; }
      &.lb{ left: 0; bottom: 0; }
      &.rt{ right: 0; top: 0; }
    }
    .tdTop{
      .tdContent{
        background-color: #ED0100;
        color: #fff;
        position: relative;
        &:before{
          content: "";
          width: 1px;
          background-color: #000;
          position: absolute;
          left: 50%; top: 100%; height: 100px;
          margin-left: -.5px;
        }
      }
    }
    .tdLightOrange{
      background-color: #FCEFC3;
      &.tdOrange{
        .tdContent{
          position: relative;
          &:before{
            content: "";
            width: 1px;
            background-color: #000;
            position: absolute;
            left: 50%; bottom: 100%; height: 100px;
            margin-left: -.5px;
          }
          &:after{
            content: "";
            width: 1px;
            background-color: #000;
            position: absolute;
            left: 50%; top: 100%; height: 100px;
            margin-left: -.5px;
          }
        }
      }
    }

    .txt-b .tdValue{ font-weight: bold; }
    .txt-u .tdValue{ text-decoration: underline; }
    .txt-i .tdValue{ font-style: italic; }
    .algn-l .tdValue{ text-align: left; }
    .algn-r .tdValue{ text-align: right; }
    .algn-c .tdValue{ text-align: center; }
    .algn-j .tdValue{ text-align: justify; }

    .vll{
      .tdBorder.lt{ border-left-color: #000; }
      .tdBorder.lb{ border-left-color: #000; }
      &.vll-t{
        .tdBorder.lb{ border-left-color: transparent; }
      }
      &.vll-b{
        .tdBorder.lt{ border-left-color: transparent; }
      }
    }
    .vlr{
      .tdBorder.rt{ border-right-color: #000; }
      .tdBorder.rb{ border-right-color: #000; }
      &.vlr-t{
        .tdBorder.rb{ border-right-color: transparent; }
      }
      &.vlr-b{
        .tdBorder.rt{ border-right-color: transparent; }
      }
    }
    .vlm{
      .tdBorder.lt{ border-right-color: #000; }
      .tdBorder.lb{ border-right-color: #000; }
      &.vlm-t{
        .tdBorder.lb{ border-right-color: transparent; }
      }
      &.vlm-b{
        .tdBorder.lt{ border-right-color: transparent; }
      }
    }
    .hlt{
      .tdBorder.lt{ border-top-color: #000; }
      .tdBorder.rt{ border-top-color: #000; }
      &.hlt-l{
        .tdBorder.rt{ border-top-color: transparent; }
      }
      &.hlt-r{
        .tdBorder.lt{ border-top-color: transparent; }
      }
    }
    .hlb{
      .tdBorder.lb{ border-bottom-color: #000; }
      .tdBorder.rb{ border-bottom-color: #000; }
      &.hlb-l{
        .tdBorder.rb{ border-bottom-color: transparent; }
      }
      &.hlb-r{
        .tdBorder.lb{ border-bottom-color: transparent; }
      }
    }
    .hlm{
      .tdBorder.lt{ border-bottom-color: #000; }
      .tdBorder.rt{ border-bottom-color: #000; }
      &.hlm-l{
        .tdBorder.rt{ border-bottom-color: transparent; }
      }
      &.hlm-r{
        .tdBorder.lt{ border-bottom-color: transparent; }
      }
    }
  }
}

.formAction{
  position: fixed;
  bottom: 0;
  left: 300px;
  right: 0;
  background-color: #fff;
  // box-shadow: 0 0 6px rgba(0,0,0,.1);
  border-top: #ddd 1px solid;
  padding: 7px 0;
  text-align: right;
  z-index: 4;
  .formActionCnt{
    position: relative;
    margin: 0 20px;
    @media (min-width: 1600px) {
      margin: 0 auto;
      max-width: 1200px;
    }
    .saveBtnCnt{
      display: flex;
      float: right;
      position: relative;
      margin-left: 22px;
      &.revertBtn{
        margin-left: 10px;
      }
      .moreOptionOverlay{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 8;
      }
      .moreOption{
        position: absolute;
        bottom: 100%;
        padding: 10px 0;
        right: -10px;
        margin-bottom: 10px;
        box-shadow: 1px 1px 2px rgba(0, 0, 0, .1);
        background-color: #fff;
        text-align: left;
        border: #ccc 1px solid;
        z-index: 9;
        border-radius: 7px;
        &:before{
          position: absolute;
          content: "";
          bottom: -10px; right: 13px;
          border-top: #ccc 10px solid;
          border-left: transparent 10px solid;
          border-right: transparent 10px solid;
        }
        &:after{
          position: absolute;
          content: "";
          bottom: -8px; right: 14px;
          border-top: #fff 9px solid;
          border-left: transparent 9px solid;
          border-right: transparent 9px solid;
        }
        li{
          list-style: none;
          padding: 8px 30px;
          padding-left: 18px;
          white-space: nowrap;
          cursor: pointer;
          position: relative;
          display: flex;
          align-items: center;
          &:before{
            content: "";
            width: 22px; height: 22px;
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 6px;
            opacity: .65;
          }
          &:hover{
            background-color: #eee;
          }
          &.draft{
            &:before{
              background-image: url(../assets/draft-o.png);
              // background-size: 22px;
            }
          }
          &.preview{
            &:before{
              background-image: url(../assets/preview.png);
            }
          }
        }
      }
      .btn{
        float: none;
        box-shadow: none;
        &.btnLoading{
          border-radius: 4px !important;
        }
      }
      .moreBtn{
        background-color: #0057d8;
        width: 26px;
        border-radius: 0 4px 4px 0;
        transition: background-color, color .2s ease;
        border-left: #144691 1px solid;;
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/top-arrow-closed-white.png);
        cursor: pointer;
        display: none;
        &:hover{
          background-color: #0067ff;
        }
      }
      &.disabled{
        .btn,
        .moreBtn{
          background-color: #ccc;
          box-shadow: none;
          cursor: default;
          border-color: #bbb;
        }
      }
      &.canSaveDraft{
        .btn{
          border-radius: 4px 0 0 4px;
          &.loading{
            border-radius: 3px;
            width: 132px;
          }
        }
        .moreBtn{
          display: block;
        }
      }
      &.loading{
        .moreBtn{
          display: none;
        }
      }
    }
    .btnConfig{
      float: right;
      width: 36px;
      height: 36px;
      padding: 0;
      position: relative;
      margin-top: 3px;
      .theBtn{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        border-radius: 50%;
        background-image: url(../assets/history.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #fff;
        opacity: .5;
        cursor: pointer;
        &:hover{
          background-color: #eee;
          opacity: 1;
        }
      }
      .configOverlay{
        position: fixed;
        left: 0; right: 0; bottom: 0; top: 0;
        z-index: 8;
      }
      .configContent{
        position: absolute;
        bottom: 100%;
        width: 240px;
        padding: 20px;
        padding-bottom: 0;
        right: -95px;
        margin-bottom: 10px;
        box-shadow: 1px 1px 2px rgba(0,0,0,.1);
        background-color: #fff;
        text-align: left;
        border: #ccc 1px solid;
        z-index: 9;
        border-radius: 7px;
        &:before{
          position: absolute;
          content: "";
          left: 50%;
          bottom: -10px;
          margin-left: 16px;
          border-top: #ccc 10px solid;
          border-left: transparent 10px solid;
          border-right: transparent 10px solid;
        }
        &:after{
          position: absolute;
          content: "";
          left: 50%;
          bottom: -8px;
          margin-left: 17px;
          border-top: #fff 9px solid;
          border-left: transparent 9px solid;
          border-right: transparent 9px solid;
        }
        .configItem{
          margin-bottom: 25px;
          h4{
            margin: 0;
            margin-bottom: 8px;
            font-size: 18px;
            font-weight: normal;
          }
          p{
            margin: 0;
            font-size: 13px;
          }
          .ciItem{
            font-size: 14px;
            margin-bottom: 8px;
            padding-bottom: 4px;
            border-bottom: #ccc 1px dotted;
            color: #444;
            &.hasDd{
              padding-top: 4px;
              .dd{
                margin: -5px 0 2px;
                float: right;
                color: #444;
              }
            }
            span{
              float: right;
              color: #444;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              display: block;
            }
            img{
              float: left;
              height: 16px;
              margin: 0 5px 0 0;
            }
            input{
              text-align: right;
              float: right;
              margin: -4px 0 0;
              border: none;
              outline: 0;
            }
            .sw{
              width: 36px;
              height: 20px;
              background-color: #ccc;
              border: #ccc 1px solid;
              border-radius: 50px;
              float: right;
              margin: -4px 0 0;
              position: relative;
              cursor: pointer;
              transition: all .2s ease;
              &:before{
                content: "";
                position: absolute;
                left: 1px; top: 1px;
                width: 18px; height: 18px;
                background-color: #fff;
                box-shadow: 2px 2px 3px rgba(0,0,0,.1);
                border-radius: 50%;
                transition: all .2s ease;
              }
              &.on{
                background-color: #ec174c;
                border-color: #ec174c;
                &:before{
                  left: 17px;
                }
              }
              &.disabled{
                background-color: #ccc;
                border-color: #ccc;
                cursor: default;
                &:before{
                  left: 1px;
                  background-color: #ddd;
                  box-shadow: none;
                }
              }
            }
            span{
              float: right;
              color: #767676;
            }
          }
        }
        .field{
          font-size: 15px;
          padding: 8px 10px;
          margin-top: 10px;
        }
        .loadingHistory{
          height: 240px;
          background-image: url(../assets/loading-2.svg);
          background-position: center;
          background-size: 36px auto;
          background-repeat: no-repeat;
        }
        .historyCnt{
          max-height: 340px;
          overflow: auto;
          border-top: #eee 1px solid;
          border-bottom: #eee 1px solid;
          margin: 0 -20px -16px;
          padding: 6px 0;
          min-height: 240px;
          box-sizing: border-box;
          &.noData{
            padding: 16px 20px;
            color: #767676;
            font-size: 14px;
          }
          .historyItem{
            padding: 8px 20px;
            transition: all .3s ease;
            cursor: pointer;
            &:hover{
              background-color: #f5f5fe;
            }
            h5{
              margin: 0;
              font-size: 15px;
              font-weight: 600;
            }
            p{
              margin: 0;
              color: #767676;
              font-weight: normal;
              font-size: 14px;
              b{
                font-weight: 600;
                color: #444;
              }
            }
          }
        }
      }
    }
  }
}
</style>
